import React, { FC } from "react";
import { Grid, InputLabel, Rating } from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

const FormRatingField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const inputRender = (isInGrid: boolean) => {
    return (
      <Rating
        style={{maxWidth:'260px', }}
        name={props?.id}
        defaultValue={2.5}
        precision={0.5}
        
      />
    );
  };
  return (
    <>
      {props?.label ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? 2 : 5}
            className={classes.labelBox}
            sx={{ marginTop:  "4px !important",marginBottom:'4px' }}
          >
            <InputLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}
              {props?.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Grid>
          <Grid
            item sx={{mt:0.5}}
            xs={12}
            sm={props?.md ? 4 : 7}
            style={{
              padding: "0px",
              border:'1px solid #eeecef',display:'flex',
              alignItems: 'center',height:'36px',
            }}
          >
            {inputRender(true)}
          </Grid>
        </>
      ) : (
        inputRender(false)
      )}
    </>
  );
};

export default FormRatingField;
